import React from 'react';
import Section from './Section';

const groups = [
  {
    label: 'Languages',
    items: ['C', 'C++', 'Python', 'Java', 'x86 Assembly', 'HTML', 'CSS', 'JavaScript', 'TypeScript'],
  },
  {
    label: 'Technologies',
    items: ['Node.js', 'React.js', 'PostgreSQL', 'Git', 'Claude', 'MCP'],
  },
  {
    label: 'Libraries',
    items: ['PyTorch', 'NumPy', 'Pandas', 'Scikit-learn'],
  },
];

const Skills = () => {
  return (
    <Section id="skills" label="Skills">
      <div className="space-y-8">
        {groups.map((group) => (
          <div key={group.label}>
            <h3 className="text-sm font-medium text-spruce">{group.label}</h3>
            <p className="mt-2 leading-relaxed text-ink/80">
              {group.items.join('  ·  ')}
            </p>
          </div>
        ))}
        <div>
          <h3 className="text-sm font-medium text-spruce">Interests</h3>
          <p className="mt-2 text-ink/80">
            Golf, pickleball, fantasy football, hiking, reading
          </p>
        </div>
      </div>
    </Section>
  );
};

export default Skills;
